import { ReactElement } from "react";
import { Button } from "./Button";

export const FinishedNoText = (): ReactElement => {
  return (
    <div className={'rules rel'}>
      <div className={'pb_finished bubble bubble_purple bubble_bottom'}>
        <h1 className={'headline font_beige'}>Упс, разлился резервуар с выгодой! Попробуйте позже!</h1>
        <div className={'rules__gears'}/>
      </div>
      <div className={'auth__machine-wrap'}>
        <div className={'auth__machine'}></div>
      </div>
      <Button cssClass={'button_green button_welcome'} clickEvent={() => window.location.reload()}>Назад</Button>
    </div>
  )
}